var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.04907e-06C9.3138 1.62848e-06 12 2.6862 12 6C12 9.3138 9.3138 12 6 12C2.6862 12 -1.62848e-06 9.3138 -1.04907e-06 6C-4.6967e-07 2.6862 2.6862 4.6967e-07 6 1.04907e-06ZM6 2.4C5.84087 2.4 5.68826 2.46322 5.57574 2.57574C5.46321 2.68826 5.4 2.84087 5.4 3L5.4 6C5.40003 6.15912 5.46327 6.31171 5.5758 6.4242L7.3758 8.2242C7.48896 8.3335 7.64052 8.39397 7.79784 8.39261C7.95516 8.39124 8.10564 8.32814 8.21689 8.21689C8.32814 8.10565 8.39124 7.95516 8.3926 7.79784C8.39397 7.64052 8.33349 7.48896 8.2242 7.3758L6.6 5.7516L6.6 3C6.6 2.84087 6.53679 2.68826 6.42426 2.57574C6.31174 2.46322 6.15913 2.4 6 2.4Z",
    fill: "#F5DD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.09ac483cdf825379e5f2b328b17796ac.svg";
export { ForwardRef as ReactComponent };